function Home() {
  return (
    <section>
      <h1>Welcome</h1>
      <p>This is a simple React SPA scaffolded with Create React App.</p>
    </section>
  );
}

export default Home;

